import React, { useEffect, useState } from "react";
import "../../Assets/styles/Honeymoon.css";
import GiftSection from "../../Components/GiftSectionComponent";

/* Automatically import all images from the folder */
const importAll = (r) => r.keys().sort().map(r);

const images = importAll(
  require.context("../../Assets/images/carousel", false, /\.(png|jpe?g|webp|jpg)$/)
);

const HoneymoonSection = () => {
  const [current, setCurrent] = useState(0);
  const [fade, setFade] = useState(true);

  const changeSlide = (newIndex) => {
    setFade(false);

    setTimeout(() => {
      setCurrent(newIndex);
      setFade(true);
    }, 250);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const newIndex = current === images.length - 1 ? 0 : current + 1;
      changeSlide(newIndex);
    }, 4000);

    return () => clearInterval(interval);
  }, [current]);

  return (
    <section className="honeymoon-section" id="honeymoon">
      <div className="honeymoon-content">
        <p className="honeymoon-kicker">LUA DE MEL</p>

        <h2 className="honeymoon-title">
          O NOSSO PRÓXIMO DESTINO
        </h2>

        <p className="honeymoon-text">
          Depois do casamento, vamos celebrar a nossa lua de
          mel nas <strong>Maldivas</strong>. É a nossa viagem de sonho desde o início do namoro, que vamos finalmente concretizar!
        </p>

        <div className="honeymoon-carousel">
          <img
            src={images[current]}
            alt={`Lua de mel ${current + 1}`}
            className={`honeymoon-image ${fade ? "fade-in" : "fade-out"}`}
          />
        </div>
      </div>

      <GiftSection />
    </section>
  );
};

export default HoneymoonSection;